import React, { useEffect, useState } from "react";
import styles from "../../styles/BrowseVideos/BrowseVideos.module.css";
import PlayableVideo from "../VideosComponents/PlayableVideo";
import { useNavigate } from "react-router-dom";
import "../../styles/Videos/video.css";
const sampleVideos = [
  {
    id: 1,
    likes: 10,
    views: 100,
    title: "Creative Thinking Workshop",
    src: "https://www.youtube.com/embed/KjDzpfS6y3w",
    thumbnail:
      "https://i.ytimg.com/vi/KjDzpfS6y3w/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAjb2FxoBSrVxk-QQX4LveMh36nRg",
  },
  {
    id: 2,
    likes: 10,
    views: 110,
    title: "Structural Thinking",
    src: "https://www.youtube.com/embed/-YAmQSNmskc?si=UNfggg-a2cm7RNHi",
    thumbnail:
      "https://i.ytimg.com/vi/-YAmQSNmskc/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLA-s0WUNHmYYpjE3x1U7l1O8q4N-g",
  },
  {
    id: 3,
    likes: 10,
    views: 110,
    title: "7 Creative Thinking Techniques",
    src: "https://www.youtube.com/embed/s-7qZmc6upo?si=VN3orBXCdR-ZoX1_",
    thumbnail:
      "https://i.ytimg.com/vi/s-7qZmc6upo/hqdefault.jpg?sqp=-oaymwEnCPYBEIoBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBWsOjb0QkqDuwf09WBXso9kuo_vQ",
  },
  {
    id: 4,
    likes: 10,
    views: 110,
    title: "The Power of Doodling",
    src: "https://www.youtube.com/embed/9Boj1Pvk7hU?si=Ysf2xyhz3jHXoMM8",
    thumbnail:
      "https://i.ytimg.com/vi/9Boj1Pvk7hU/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBLyWacs4xD0Iofgy2wpwGcx9IW5A",
  },
  {
    id: 5,
    likes: 10,
    views: 110,
    title: "Design Thinking - Part 1",
    src: "https://www.youtube.com/embed/bq9tQ8lpJTA?si=PsfzoVhuD4iM9sMU",
    thumbnail:
      "https://i.ytimg.com/vi/bq9tQ8lpJTA/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBSk0goau1v8WNeTAKbt5HdUwj7ag",
  },
  {
    id: 6,
    likes: 140,
    views: 10000,
    title: "Design Thinking - Part 2",
    src: "https://www.youtube.com/embed/FmZjSlUbsh4?si=iBxRTvoykk72QsRg",
    thumbnail:
      "https://i.ytimg.com/vi/FmZjSlUbsh4/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBnf6XU26AFcgRsI_hdAeLouIL7RA",
  },
];
const BrowseVideos = ({ backgroundType = 'gradient' }) => {
  const style = {
    background: backgroundType === "gradient" 
      ? "linear-gradient(to bottom, #111111 0%, #C7313D 100%)" 
      : "black",
  };
  const [videos, setVideos] = useState([]); // To store the videos
  const [videosFilter, setVideosFilter] = useState("ALL"); // To store the videos
  const [currentVideo, setCurrentVideo] = useState(null); // To store the currently playing video
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  // Handle mouse wheel event for horizontal scrolling
  useEffect(() => {
    const container = document.getElementById(styles.playableVideoContainer);
    const handleWheel = (e) => {
      if (container) {
        container.scrollLeft += e.deltaY; // Scroll horizontally
        e.preventDefault(); // Prevent default vertical scroll
      }
    };
    if (container) {
      // Add the listener with the { passive: false } option
      container.addEventListener("wheel", handleWheel, { passive: false });
    }
    return () => {
      if (container) {
        container.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);

  useEffect(() => {
    // Filter videos whenever the filter changes
    if (videosFilter === "ALL") {
      setVideos(sampleVideos);
    } else if (videosFilter === "MV") {
      setVideos([...sampleVideos].sort((a, b) => b.views - a.views)); // Most Viewed
    } else if (videosFilter === "ML") {
      setVideos([...sampleVideos].sort((a, b) => b.likes - a.likes)); // Most Liked
    }
  }, [videosFilter]);

  const handleClick = () => {
    navigate("/videos");
  };
  const handleVideoClick = (video) => {
    setCurrentVideo(video); // Set the clicked video as the currently playing video
  };

  const closeIframe = () => {
    setCurrentVideo(null); // Close the iframe
  };

  const handleFilterVideos = (filter) => {
    setVideosFilter(filter);
  };
  const translate = (direction) => {
    const container = document.getElementById(styles.playableVideoContainer);
    if (!container) return;
    // Fetch child element for exact width
    const firstVideoItem = container.querySelector(`.playableVideoContainer`);
    // console.log(firstVideoItem.getBoundingClientRect().width);
    
    const videoWidth = firstVideoItem ? firstVideoItem.getBoundingClientRect().width : 420; // Fallback to 420px

    // const firstVideoItem = container.querySelector(
    //   `.${Video.playableVideoContainer}`
    // );
    // const firstVideoItem = container.querySelector(".playableVideoContainer");
    // const videoWidth = firstVideoItem ? firstVideoItem.offsetWidth : 420; // Fallback to 420px

    // Calculate scroll amount
    const scrollAmount = videoWidth + 2;
    // Determine the current scroll position and new target
    const currentScrollPosition = container.scrollLeft;
    const targetScrollPosition = currentScrollPosition + direction * scrollAmount;
    container.scrollTo({
      left: targetScrollPosition,
      behavior: "smooth",
    });
    setCurrentIndex((prevIdx) => (prevIdx += direction));
  };
  return (
    <div id={styles.videosContainer} style={style}>
      <h1 id={styles.videosTitle}>Browse Through Our Trainings</h1>
      <div id={styles.browseVideosFilter}>
        <div
          className={`${styles.browseVideosFilterBtn} ${
            videosFilter === "ALL" ? styles.active : ""
          }`}
          onClick={() => handleFilterVideos("ALL")}
        >
          All
        </div>
        <div
          className={`${styles.browseVideosFilterBtn} ${
            videosFilter === "MV" ? styles.active : ""
          }`}
          onClick={() => handleFilterVideos("MV")}
        >
          Most Viewed
        </div>
        <div
          className={`${styles.browseVideosFilterBtn} ${
            videosFilter === "ML" ? styles.active : ""
          }`}
          onClick={() => handleFilterVideos("ML")}
        >
          Most Liked
        </div>
      </div>
      <hr
        style={{
          width: "95%",
          margin: "auto",
          marginBottom: "2rem",
          opacity: "30%",
        }}
      />
      <div style={{ position: "relative" }}>
        {currentIndex > 0 && (
          <div
            id={styles.leftIcon}
            style={{
              position: "absolute",
              top: "50%",
              left: "1%",
              transform: "translate(0%, -50%)",
            }}
            onClick={() => translate(-1)}
          >
            <img src="/arrow_circle_right.svg" alt="left_icon" />
          </div>
        )}
        <div id={styles.playableVideoContainer}>
          {videos.map((video) => (
            <PlayableVideo
              key={video.id}
              thumbnailUrl={video.thumbnail}
              title={video.title}
              width={"420px"}
              onClick={() => handleVideoClick(video)} // Handle video click
            />
          ))}
        </div>
        {currentIndex < videos.length - 1 && (
          <div
            id={styles.rightIcon}
            style={{
              position: "absolute",
              top: "50%",
              right: "1%",
              transform: "translate(0%, -50%)",
            }}
            onClick={() => translate(+1)}
          >
            <img
              src="/arrow_circle_right.svg"
              alt="right_icon"
              style={{ rotate: "180deg" }}
            />
          </div>
        )}
      </div>
      {currentVideo && (
        <div className={styles.iframeOverlay}>
          <div className={styles.iframeContainer}>
            <iframe
              src={currentVideo.src}
              title={currentVideo.title}
              width="800px"
              height="450px"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <button className={styles.closeButton} onClick={closeIframe}>
              Close
            </button>
          </div>
        </div>
      )}
      <div className={styles.btn} onClick={handleClick}>
        Premium Courses
      </div>
    </div>
  );
};

export default BrowseVideos;
